export const initialState = {
  userName: null,
  userDetails: null,
  permissions: [],
  assignedClients: [],
  assignedClientsLegacy: [],
  assignedSubUnits: [],
  assignedProfitCenter: [],
  teams: [],
  roles: [],
  subordinates: [],
}

export const userReducer = (state, action) => {
  switch (action.type) {
    case 'SET_USERNAME':
      return { ...state, userName: action.userName }
    case 'SET_USERDETAILS':
      return { ...state, userDetails: action.userDetails }
    case 'SET_PERMISSIONS':
      return { ...state, permissions: action.permissions }
    case 'SET_ASSIGNEDCLIENTS':
      return { ...state, assignedClients: action.assignedClients }
    case 'SET_ASSIGNEDCLIENTSLEGACY':
      return { ...state, assignedClientsLegacy: action.assignedClientsLegacy }
    case 'SET_ASSIGNEDSUBUNITS':
      return { ...state, assignedSubUnits: action.assignedSubUnits }
    case 'SET_ASSIGNEDPROFITCENTER':
      return { ...state, assignedProfitCenter: action.assignedProfitCenter }
    case 'SET_TEAMS':
      return { ...state, teams: action.teams }
    case 'SET_ROLES':
      return { ...state, roles: action.roles }
    case 'SET_SUBORDINATES':
      return { ...state, subordinates: action.subordinates }
    default:
      return state
  }
}
